export const Tokens = {
    Countdown: "{countdown}",
    Date: "{date}",
    SelectedRecipes: "{selectedRecipes}",
    MealQuantity: "{mealQuantity}",
    Limit: "{limit}",
    Day: "{day}",
    Action: "{action}",
    ProgramMealName: "{programMealName}",
    AddedMeals: "{addedMeals}",
    RemovedMeals: "{removedMeals}",
    MealName: "{mealName}",
    OrderNumber: "{orderNumber}",
    PlaceHolder: "{placeHolder}",
    MealType: "{mealType}",
    Min: "{min}",
    Max: "{max}",
    Ingredients: "{ingredients}",
    CompanyName: "{CompanyName}",
    Price: "{price}",
    MealEntityNamePlural: "{meal_entity_name_plural}",
    MealEntityName: "{meal_entity_name}",
};
